import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { genericRequiredFieldError } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { primaryContactEmail },
} = loanFormModel;

export class PrimaryContactEmailValidation implements ValidationSchema {
  public name: string = primaryContactEmail.name;
  public label: string = primaryContactEmail.label;
  public dependsOn: string[] = [];
  public type = 'email';
  public required = {
    message: genericRequiredFieldError,
    value: primaryContactEmail.required,
  };
  public nullable = true;
}
export default new Validation(new PrimaryContactEmailValidation());
